import React from 'react';
import { Box, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';

interface ScrumAILogoProps {
  fontSize?: string | number;
  iconSize?: number;
  showBadge?: boolean;
  clickable?: boolean;
  onClick?: () => void;
}

export const ScrumAILogo: React.FC<ScrumAILogoProps> = ({
  fontSize = '1.4rem',
  iconSize = 32,
  showBadge = false,
  clickable = false,
  onClick
}) => {
  return (
    <Box
      onClick={onClick}
      aria-label="ScrumAIApp"
      title="ScrumAIApp"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.2,
        cursor: clickable ? 'pointer' : 'default',
        userSelect: 'none',
        transition: 'transform 0.15s ease',
        '&:hover': clickable ? { transform: 'scale(1.02)' } : {}
      }}
    >
      {/* Neumorphic Icon Badge */}
      <Box
        sx={{
          width: iconSize,
          height: iconSize,
          borderRadius: `${Math.round(iconSize * 0.35)}px`,
          bgcolor: 'var(--hp-surface-raised)',
          boxShadow: '3px 3px 8px var(--hp-shadow-dark), -3px -3px 8px var(--hp-shadow-light)',
          border: '1px solid var(--hp-border)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--hp-primary)',
          flexShrink: 0
        }}
      >
        <AutoAwesome sx={{ fontSize: iconSize * 0.58 }} />
      </Box>

      {/* Styled Wordmark matching exact app name: ScrumAIApp */}
      <Box sx={{ display: 'inline-flex', alignItems: 'baseline', lineHeight: 1 }}>
        <Typography
          component="span"
          sx={{
            fontWeight: 800,
            fontSize,
            letterSpacing: '-0.5px',
            color: 'var(--hp-text)',
            fontFamily: 'var(--hp-font)'
          }}
        >
          Scrum
        </Typography>
        <Typography
          component="span"
          sx={{
            fontWeight: 900,
            fontSize,
            letterSpacing: '-0.5px',
            color: 'var(--hp-primary)',
            fontFamily: 'var(--hp-font)',
            textShadow: '0 2px 8px rgba(79, 107, 255, 0.25)'
          }}
        >
          AI
        </Typography>
        <Typography
          component="span"
          sx={{
            fontWeight: 800,
            fontSize,
            letterSpacing: '-0.5px',
            color: 'var(--hp-text)',
            fontFamily: 'var(--hp-font)'
          }}
        >
          App
        </Typography>

        {showBadge && (
          <Box
            component="span"
            sx={{
              ml: 1,
              px: 0.8,
              py: 0.2,
              borderRadius: '6px',
              fontSize: '0.65rem',
              fontWeight: 700,
              bgcolor: 'var(--hp-primary-light)',
              color: 'var(--hp-primary)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
          >
            v2.0
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ScrumAILogo;
